import React from 'react';
import { Document, Page, Text, Image, StyleSheet, Font, View } from '@react-pdf/renderer';
import logo from '../../assets/images/login-logo.png';
import img1 from '../../assets/images/icons/transit-partner.png';
import img2 from '../../assets/images/icons/commuters.png';
import img3 from '../../assets/images/icons/active-vendors.png';
import img4 from '../../assets/images/icons/total-routes.png';
import img5 from '../../assets/images/icons/distance.png';
import img6 from '../../assets/images/icons/emission.png';
import img7 from '../../assets/images/icons/reward-points.png';
import img8 from '../../assets/images/icons/reward-redeem.png';

const DashboardPDF = ({ dashboardData, units, chartImage }) => {
    const getValueWithUnit = (title, value) => {
        if (title === 'Distance') return `${value} ${value !== undefined ? units?.distanceUnit || '' : ''}`;
        if (title === 'GHG Emissions') return `${value} ${value !== undefined ? units?.ghgUnit || '' : ''}`;
        return value;
    };
    return (
        <Document>
            <Page style={styles.body}>
                <Image style={styles.image} src={logo} />
                <View style={styles.mainContainer}>
                    <View style={styles.dataBox}>
                        <Image src={img1} style={{ maxWidth: 50, maxHeight: 50 }} />
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Transit Partner</Text>
                            <Text style={styles.subtitle}>{dashboardData?.transitAgencies}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <Image src={img2} style={{ maxWidth: 50, maxHeight: 50 }} />
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Commuters</Text>
                            <Text style={styles.subtitle}>{dashboardData?.commuters}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <Image src={img4} style={{ maxWidth: 50, maxHeight: 50 }} />
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Total Routes</Text>
                            <Text style={styles.subtitle}>{dashboardData?.routes}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <Image src={img5} style={{ maxWidth: 50, maxHeight: 50 }} />
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Distance</Text>
                            <Text style={styles.subtitle}>{getValueWithUnit('Distance', dashboardData?.totalDistance)}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <Image src={img3} style={{ maxWidth: 50, maxHeight: 50 }} />
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Active Vendors</Text>
                            <Text style={styles.subtitle}>{dashboardData?.vendors}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <Image src={img6} style={{ maxWidth: 50, maxHeight: 50 }} />
                        <View style={styles.textualData}>
                            <Text style={styles.title}>GHG Emissions</Text>
                            <Text style={styles.subtitle}>{getValueWithUnit('GHG Emissions', dashboardData?.GHGsaved)}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <Image src={img7} style={{ maxWidth: 50, maxHeight: 50 }} />
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Earned Points</Text>
                            <Text style={styles.subtitle}>{dashboardData?.earnedPoints}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <Image src={img8} style={{ maxWidth: 50, maxHeight: 50 }} />
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Redeem Rewards</Text>
                            <Text style={styles.subtitle}>{dashboardData?.totalRewards}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.mainContainer}>
                    {chartImage ? (
                        <Image src={chartImage} alt="chartImage" style={{ maxWidth: 509, maxHeight: 500, width: 509, height: 278 }} />
                    ) : (
                        <Text>Error: Chart image is undefined or invalid</Text>
                    )}
                </View>
                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} fixed />
            </Page>
        </Document>
    );
};

Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const styles = StyleSheet.create({
    body: {
        paddingTop: 25,
        paddingBottom: 65,
        paddingHorizontal: 35
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    dataBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        border: '1px solid #d3d3d3',
        borderRadius: '10px',
        padding: '5px',
        width: '250px',
        height: 'auto',
        margin: '5px'
    },
    textualData: {
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        marginLeft: '10px'
    },
    title: {
        fontSize: 18,
        textAlign: 'start',
        fontFamily: 'Oswald'
    },
    subtitle: {
        fontSize: 14,
        fontFamily: 'Oswald',
        color: '#505050',
        fontWeight: 'bold'
    },
    text: {
        margin: 12,
        fontSize: 14,
        textAlign: 'justify',
        fontFamily: 'Times-Roman'
    },
    image: {
        marginVertical: 50,
        marginHorizontal: 100
    },
    header: {
        fontSize: 18,
        marginBottom: 20,
        textAlign: 'center',
        color: 'black',
        fontWeight: 'semibold'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey'
    }
});

export default DashboardPDF;
